import * as React from "react";
import { Badge } from "../badge/Badge";
import { IdBadgePosition } from "../badge/IdBadgePosition";
import { ButtonAddResource } from "../common/ButtonAddResource";
import { Resource } from "../resource/Resource";
export var ResourceWithButton = function (_a) {
    var resource = _a.resource, className = _a.className, onButtonClick = _a.onButtonClick, styleId = _a.styleId, backgroundSize = _a.backgroundSize, backgroundClassName = _a.backgroundClassName, _b = _a.centerText, centerText = _b === void 0 ? true : _b;
    return (React.createElement("div", { className: "flex flex--guts resource-with-button" },
        React.createElement(Resource, { resource: resource, className: className, backgroundSize: backgroundSize, backgroundClassName: backgroundClassName, styleId: styleId, centerText: centerText }),
        React.createElement(Badge, { position: IdBadgePosition.Right },
            React.createElement(ButtonAddResource, { className: "resource-add-button", onClick: onButtonClick }))));
};



//////////////////
// WEBPACK FOOTER
// ./src/features/generic/resource-with-button/ResourceWithButton.tsx
// module id = 887
// module chunks = 3